import { render } from "./CrowdsourcingQuestion.vue?vue&type=template&id=18d3f78c&scoped=true"
import script from "./CrowdsourcingQuestion.vue?vue&type=script&lang=js"
export * from "./CrowdsourcingQuestion.vue?vue&type=script&lang=js"

import "./CrowdsourcingQuestion.vue?vue&type=style&index=0&id=18d3f78c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d3f78c"]])

export default __exports__